export function Logo({ compact = false }) {
  return (
    <span className="flex items-center gap-2.5" data-testid="brand-logo">
      <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-forest text-cream dark:bg-terracotta-500">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M12 22V8" />
          <path d="M12 8C12 4 9 2 5 2c0 4 3 6 7 6z" />
          <path d="M12 14c0-4 3-6 7-6 0 4-3 6-7 6z" />
        </svg>
      </span>
      {!compact && (
        <span className="font-heading text-lg font-semibold tracking-tight text-foreground">
          Evol <span className="text-terracotta-500">&amp;</span> Troppus
        </span>
      )}
    </span>
  );
}
